import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { MatNativeDateModule } from '@angular/material/core';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import { OverlayModule } from '@angular/cdk/overlay';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { EffectsModule } from '@ngrx/effects';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

import { AppRoutingModule } from './app-routing.module';
import { AuthModule } from './authentication/authentication.module';
import { CoreModule } from './core/core.module';

import { AppComponent } from './app.component';

import { EmailService } from './core/services/email.service';
import { ToastService } from './core/services/toast.service';

import { AuthenticationInterceptor } from './authentication/services/authentication.interceptor';
import { AppEffects } from './store/app.effects';
import { CoreEffects } from './core/store/core.effects';

import { reducers } from './store/app.state';
import { environment } from '../environments/environment';
import { Intercept404Service } from './core/services/intercept-404.service';
import { TitleCasePipe } from '@angular/common';
import { resetState } from './authentication/store/authentication.reducer';
import { UIEffects } from './ui/store/ui.effects';
import { UserEffect } from './users/store/user.effect';
import { MatomoModule } from './shared/matomo.module';
import { ProjectModule } from './project/project.module';
import { AlgoSettingsModule } from './algo-settings/algo-settings.module';

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatNativeDateModule,
    OverlayModule,
    CoreModule,
    AuthModule,
    MatomoModule,
    StoreModule.forRoot(reducers, { metaReducers: [resetState] }),
    StoreRouterConnectingModule.forRoot(),
    EffectsModule.forRoot([AppEffects, UIEffects, UserEffect]),
    !environment.production ? StoreDevtoolsModule.instrument({ connectInZone: true }) : [],
    ProjectModule,
    AlgoSettingsModule
  ],
  providers: [
    TitleCasePipe,
    ToastService,
    CoreEffects,
    EmailService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthenticationInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: Intercept404Service,
      multi: true
    },
    { provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: { duration: 3500 } },
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class AppModule {}
